import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomizedAccordions from "../components/homepage/accordion";
import CustomContainer from "../components/layout/container";
import CustomHeader from "../components/layout/header";

import teamMT from "../images/MT_Head_Sketch.jpg";
import teamBSloan from "../images/Dr_Brian_Sloan_GreySketch.jpg";
import teamStuE from "../images/Stu_Headshot._Sketch.jpg";
import teamPaulR from "../images/PaulResnikHeadshotSketch2.jpg";
import teamCodeLines from "../images/CodeLines_Original.jpg";
import DonPhillips from "../images/DonPhillips_Head.jpg";
import NickClifford from "../images/NickClifford.jpg";
import DavidHorsler from "../images/DavidHorsler.png";
import NetworkAssoc from "../images/Network_Associates_Green.jpg";
import teamLibBooks from "../images/LibraryBooks_Original.jpg";

const carouselHeight = "150px";
const Team = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { teamSubPage } = useParams();

  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [links, setLinks] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] = useState("");

  const getRouterData = () => {
    if (teamSubPage) {
      const url = teamSubPage.replace(/-/g, " ");
      setLinks(url);
      const finalString = url.split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      setPageTitle(finalString);
      setTimeout(() => {
        setborderColorToHighlight(theme.palette.primary.dark);
      }, 100);
    }
  };

  const breadcrumbData = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: `Team (${pageTitle})`,
      link: `/team/${teamSubPage}`,
    },
  ];

  useEffect(() => {
    getRouterData();
  }, [teamSubPage]);

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={`Team <span style="font-size:1.2rem;color:rgba(84,77,160,1);"> - MEF Management Team</span>`}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                //                imgSrc="/images/ModelSchemaPaleMauve.jpg"
                imgSrc={teamMT}
                title="Economics/Energy Modelling"
                objectFit="contain"
                subTitle="Structural Modelling - ?GEM Models"
                borderColor={
                  links == "model team" ? borderColorToHighlight : 'none'
                }

                body={`MEF's modelling team is led by <strong>Martin Turner</strong> who has 35 years experience working as an Applied Economist & macro modeller across HM Treasury, EY ITEM Club, academia
                and consultancy.`}
              />
              <CustomizedAccordions
                title="Profile"
                //                imgSrc="/images/MT_Head_Sketch.jpg"
                body="Martin is also a visiting academic at Alliance Manchester Business School where he lectures in Applied Global Macroeconomics/Trade,
                Globalisation and Portfolio Management. He also lectures using the risk2NZ App on various Executive Education & Summer Schools at AMBS"
              />
              <CustomizedAccordions
                title="Work Streams"
                body="Martin works with a number of Associates and Academics on specific modelling projects and also with other MEF team members. He has been heavily involved in MEF online App development liaising with Software Engineers
                to operationalise MEF's model suite for mobile/web Applications."
              />
                            <ContentCards
                imgSrc={DonPhillips}
                title="Research/Outreach"
                subTitle="Chief Research Officer"
                objectFit="contain"
                //                subTitle="Leveraging Networks Externally"
                borderColor={
                  links == "mef associates"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`<b>Don Phillips</b> researches business opportunities, partnerships, dataset capture and drives <b>marketing</b> at MEF; he also 
                  builds out MEF's <b>Executive Education</b> programmes to deliver risk awareness/mitigation and business transformation Globally.`} />
              <CustomizedAccordions
                title="Profile"
                body={`Don is the founder and managing director of <strong>Lloyd-Davies Associates Ltd</strong>. He had a long career with <b>Hewlett-Packard</b> rising to 
                Operations Director for the UK/Ireland & EMEA, leaving in 2003 to form his own consultancy business- LDA's core value 
                proposition has been the aggregation of data capture and knowledge into interactive <b>‘playbooks’</b> and 'Notebooks' - on the
                'Cohesion' platform - that assist in the dissemination of shared experiences between businesses in order to foster growth among individuals, 
                communities, and enterprises. `}
              />
              <CustomizedAccordions
                title="Work Streams"
                body={`As Founder and MD of Senaryo Services Ltd, Don is building the exemplars of engagement of the <b>MEF 
                Risk-Opportunity Framework</b> and Cohesion within the <b>ESG compliance</b>, innovation management and customer service markets.
                Driving the engagement with Executive Education and Business Transformation markets through partners to facilitate 
                the Risk-Opportunity Framework being leveraged globally`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={teamBSloan}
                title="Economics/Policy Analysis(SMEs)"
                objectFit="contain"
                subTitle="SME Engagement"
                borderColor={
                  links == "SME team"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`<strong>Dr Brian Sloan</strong>, MBA is an Applied Economist who has previously worked as Deputy Regional Agent (North West) for the Bank of England after a long career as Chief Economist at the Greater Manchester Chamber of Commerce</a>.`}
              />
              <CustomizedAccordions
                title="Profile"
                body={`Brian has an extensive network of business contacts in the North West as well as a deep insight into how national (Monetary) Policy impacts local SME business. As such he is an invaluable advisor to MEF Ltd
                with his experience of the operation of the Monetary Policy Committee (MPC) process in setting UK official UK short, policy interest rates`}
              />
              <CustomizedAccordions
                title="Work Streams"
                body={`Brian focuses on translating Economic & Policy developments/risks at the Global/National levels into tangible risk mitigation advice for local firms. And as an experienced academic (Phd and MBA from AMBS) he is a
                crucial addition to MEF's Executive Education services.`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={teamLibBooks}
                title="Education/Skills Team"
                subTitle="Real World Tools/Apps"
                borderColor={
                  links == "education team"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`The Education Team provides classroom Apps, Custom Course Units/Modules and consultancy on integration of the latter into new or existing teaching material. `}
              />
              <ContentCards
                imgSrc={NickClifford}
                title="Dr Nick Clifford"
                objectFit="contain"
                //                subTitle="Leveraging Networks Externally"
                borderColor={
                  links == "mef associates"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`<strong>Dr Nick Clifford</strong> is co-founder of Logic Ltd which is a organisational change and development consultancy that is 
                  taking his doctorate research conclusions forward to practise`} />
              <CustomizedAccordions
                title="Profile"
                body={`<p>As well as running Logic with David Horsler, Nick is also an Honorary Research Fellow at AMBS
                  and leads on programme direction and management for customised programmes. Nick’s early career was in local government land-use 
                  development planning in London and later in land reclamation & environmental improvement projects as a capital programmes manager 
                  leading on a portfolio of schemes in London and then Manchester. Nick specialised in running capital expenditure projects and 
                  programmes for reclamation and environmental improvements of derelict and abandoned sites. He then became lead officer for 
                  Manchester City's sustainability work. </p> `}
              />
              <CustomizedAccordions
                title="Undergrad, Postgrad & Executive Education Modules"
                body={`For the following subject streams, MEF can integrate its Apps, Models & Tools into existing course material to bring content alive and fill
                typical curricula gaps of data, policy and applied analysis. MEF has been working with Alliance Manchester Business Schools (AMBS) Executive Education over the last 25 years,
                in designing & delivering custom units, some based around the risk2NZ App.`}
              />
              <CustomizedAccordions
                title="Academic Satellite (Economic/Emissions) models - linked to mGEM"
                body={`Just as MEF can build/estimate bespoke, customer models in their specific domain areas, it can do the same for academic partners looking to
                add Global consistency to their more focused "micro" or domain-level models that need to be simulated within a Global context. 
                A clear seperation of models allows a co-operative research relationship without compromising IP issues. The <a title="student Global Econometric Model"> stuGEM </a> provides
                wider risk analysis/quantification of overseas student numbers over HE-provider's planning horizons`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                //                imgSrc="/images/PortfolioAllocationBlue.jpg"
                imgSrc={teamPaulR}
                title="Finance/Portfolio Team"
                objectFit="contain"
                subTitle="Senior consultant"
                borderColor={
                  links == "portfolio team"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`<strong>Paul Resnik</strong> is a serial entrepreneur with a distinguished career in Financial Services; he is currently Chief Ethics Officer of the <a href='/why/case-study/SAI'>  Suitable Advice Institute</a>.`}
              />
              <CustomizedAccordions
                title="Profile"
                body={`Paul was Co-founder & Director of FinaMetrica Pty Limited; he is an innovator in financial services which includes, founding investment platforms and fund supermarkets, cash-flow modelling technology, and global risk profiling technology: FinaMetrica.`}
              />
              <CustomizedAccordions
                title="Work Streams"
                body={`For over 30 years Paul has been at the forefront of improving the advice process for both clients and advisers. Paul’s contribution to developing suitable advice - particularly in assessing risk - is probably unparalleled.`}
              />
              <ContentCards
                imgSrc="/images/PortfolioAllocationBlue.jpg"
                 imgSrc={teamStuE}
                title="Finance/Portfolio Modelling"
                objectFit="contain"
                subTitle="Macro-Financial Linkages"
                borderColor={
                  links == "portfolio team"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Stuart Erskine is a behavioural Economist who leads the Finance/Portfolio team that provides bespoke services to investment professionals`}
              />
              <CustomizedAccordions
                title="Profile"
                body={`Stuart holds an MA in Economics and has 30 years experience working in the Financial Services sector in both client facing
                and technical functions; with a particular expertise in assessing consumer attitude to investment risk. Stuart was an examiner and
                question setter for a number of professional qualifications in the financial services sector.  He has authored a number of papers
                in the area of financial risk and use of technology in investment sector.`}
                imgSrc="/images/Stu_Headshot._Sketch.jpg"
              />
              <CustomizedAccordions
                title="Work Streams"
                body={`Stuart works with fund managers and financial advisors; developing investment propositions, fund launches,
                assessing risk rating of funds and developing suitable financial advice processes.  Stuart is also Director of
                Research and Strategy for the <a href='/why/case-study/SAI'>  Suitable Advice Institute</a>.`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={NetworkAssoc}
                title="MEF Associates"
                objectFit="fill"
                subTitle="Leveraging Networks Externally"
                borderColor={
                  links == "mef associates"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`MEF works with various, specialist, experienced Associates with whom it collaborates to offer more rounded advice & assistance to clients.
                In turn, MEF acts an external Associate to a number of partner organisations and firms like Senaryo Services, and LOGIC`}
              />
              {/* Some of these were MEF clients with whom an organic working relationship and mutual-trust emerged over time */}
              <ContentCards
                imgSrc={DavidHorsler}
                title="David Horsler"
                objectFit="contain"
                //                  subTitle="Leveraging Networks Externally"
                borderColor={
                  links == "mef associates"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`<strong>David Horsler</strong> is co-founder of Logic Ltd with Nick Clifford and has over 30 years of Local Government experience, 20 years as a senior manager.`} />
              <CustomizedAccordions
                title="Profile"
                body={`<p> David has a strong track record in devising and delivering organisational development programmes. He has developed particular interest in situated learning and the 
                    relationship between physical environments and wider OD outcomes. As Assistant Director for Organisational Development at Salford council, David 
                    worked alongside Dr Nick Clifford from 2004 to 2011 to deliver a transformational change programme  </p>`}
              />
                            <ContentCards
                imgSrc={teamCodeLines}
                title="Software Engineers"
                objectFit="fill"
                subTitle="Custom Mobile/Web Tools"
                borderColor={
                  links == "software engineers"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`MEF works with various Associate coders to build out its web Apps such as risk2NZ. We have an ongoing IT research relationship
                with Goodenough College, London, UK - part of the University of London family. We also work with Manchester University Computer Science Dept.
                with whom MEF collaborate on Research Council/Innovate UK joint Funding bids. More recently, MEF have been working with the Salford University AI Foundry
                to deploy best-practise AI and Data Science concepts in it's tools/Apps.`}
              />
              <CustomizedAccordions
                title="Manchester University Computer Science Dept."
                body={`MEF have participated in UKRI/Innovate UK research bids, most recently <b>John Keane</b> (Prof. of Data Engineering-Computing Science) and
                Xiaojun Zeng (Prof. of Machine Learning and Robotics-Computing Science)  `} />
              <CustomizedAccordions
                title="Goodenough College, London - IT/Computing Division "
                body={`MEF has been working with Rob and Dan of Goodenough College IT Dept. who have provided ongoing server/software assistance & hardware for MEF to develop/test its educational Apps/tools.
                Goodenough College has excellent links with some of the leading Colleges/Departments of University of London's wider academic community'`}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default Team;
// DynamicTeamPage.getInitialProps = async ({ teamData }: any) => {
//   return teamData;
// };
